import type { Action } from 'svelte/action'
import Sparkle from './Sparkle.svelte'
import { mount, unmount } from 'svelte'

export const sparkling: Action<HTMLElement, { tier: number }> = (
  node,
  { tier },
) => {
  const sparkle = mount(Sparkle, {
    target: node,
    props: { target: node, tier },
  })

  return {
    destroy() {
      unmount(sparkle)
    },
  }
}
